export class SettingsRegulationCategory {
  id: any;
  name: any;
  createdDate: any;
  lastUpdatedDate: any;
  numberOfRegulations: any;

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.createdDate = data.createdDate;
      this.lastUpdatedDate = data.lastUpdatedDate;
      this.numberOfRegulations = data.numberOfRegulations;
    }
  }
}
